import { useMutation, useQuery } from 'react-query';
import { AniPayAddAlias, AniPayAliasAction } from 'app/pages/anipay/model/types';
import anipayService from 'app/pages/anipay/api/anipayService';

export const useGetAliases = () => {
  const {
    isLoading: isLoadingAniPayGetAliases,
    isFetching,
    data: dataGetAliases,
    refetch: refetchAniPayGetAliases,
  } = useQuery('add-alias', anipayService.anipayGetAliases);

  return {
    isLoadingAniPayGetAliases,
    isFetching,
    dataGetAliases,
    refetchAniPayGetAliases,
  };
};

export const useAccountAction = () => {
  return useMutation((data: AniPayAliasAction) => anipayService.anipayAccountAction(data));
};

export const useAddAlias = () => {
  return useMutation((data: AniPayAddAlias) => anipayService.anipayAddAlias(data));
};

export const useAliasSendOtp = () => {
  return useMutation((data: any) => anipayService.anipayAliasSendOtp(data));
};
